import { useEffect, useState } from "react";
import { PortalShell, useUnread } from "@/components/portal/PortalShell";
import { ProductsTable } from "@/components/portal/ProductsTable";
import { OrdersPanel } from "@/components/portal/OrdersPanel";
import { Manufacturers } from "@/components/portal/Manufacturers";
import { Approvals } from "@/components/portal/Approvals";
import { LiveActivity } from "@/components/portal/LiveActivity";
import { api } from "@/lib/api";

function Overview({ stats, go }) {
  const cards = [
    { k: "new_orders", l: "Orders to assign", tab: "orders" },
    { k: "unread", l: "Unread updates", tab: "orders" },
    { k: "pending_approvals", l: "Pending approvals", tab: "approvals" },
    { k: "out_of_stock", l: "Out of stock", tab: "catalogue" },
    { k: "live_products", l: "Live items", tab: "catalogue" },
  ];
  return (
    <div data-testid="admin-overview">
      <h1 className="font-display text-3xl sm:text-4xl">Namaste, <span className="font-serif-it text-[#E06D3B]">keeper</span></h1>
      <p className="text-[#A89F91] mt-2">Everything happening across the looms today.</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-8">
        {cards.map((c) => (
          <button key={c.k} onClick={() => go(c.tab)} className="text-left rounded-sm border border-[#D4AF37]/15 bg-[#14110E] p-5 hover:bg-[#1D1915] transition-colors" data-testid={`stat-${c.k}`}>
            <p className="font-display text-4xl text-[#F3E5AB]">{stats?.[c.k] ?? "–"}</p>
            <p className="text-[11px] uppercase tracking-[0.15em] text-[#6E6558] mt-2">{c.l}</p>
          </button>
        ))}
      </div>
      <div className="mt-8 max-w-2xl"><LiveActivity onOpenOrders={() => go("orders")} /></div>
    </div>
  );
}

export default function AdminPortal() {
  const [tab, setTab] = useState("overview");
  const [products, setProducts] = useState([]);
  const [mfrs, setMfrs] = useState([]);
  const [stats, setStats] = useState(null);
  const [unread, refreshUnread] = useUnread();

  const loadProducts = () => api.get("/portal/products").then((r) => setProducts(r.data)).catch(() => {});
  const loadMfrs = () => api.get("/admin/manufacturers").then((r) => setMfrs(r.data)).catch(() => {});
  const loadStats = () => api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  const reloadAll = () => { loadProducts(); loadStats(); };

  useEffect(() => {
    loadProducts();
    loadMfrs();
    loadStats();
  }, [tab]);

  useEffect(() => {
    loadStats();
  }, [unread]);

  const pending = products.filter((p) => p.status === "pending").length;
  const tabs = [
    { k: "overview", l: "Overview" },
    { k: "orders", l: "Orders", badge: unread },
    { k: "catalogue", l: "Catalogue" },
    { k: "approvals", l: "Approvals", badge: pending },
    { k: "manufacturers", l: "Manufacturers" },
  ];

  return (
    <PortalShell title="Admin portal" tabs={tabs} active={tab} setActive={setTab} unread={unread}>
      {tab === "overview" && <Overview stats={stats} go={setTab} />}
      {tab === "orders" && <OrdersPanel isAdmin manufacturers={mfrs} onRead={refreshUnread} />}
      {tab === "catalogue" && <ProductsTable products={products.filter((p) => p.status !== "pending")} isAdmin reload={reloadAll} />}
      {tab === "approvals" && <Approvals products={products} reload={reloadAll} />}
      {tab === "manufacturers" && <Manufacturers list={mfrs} reload={loadMfrs} />}
    </PortalShell>
  );
}
